<template>
  <div class="user-bar-region">
    <div class="user-bar-place-holder">

    </div>
    <div class="user-bar-main">
      <div class="user-bar-persona-switcher" role="navigation" :aria-label="mainNavBarAriaLabel">
        <persona-switcher></persona-switcher>
      </div>
      <div class="user-bar-menus">
        <top-level-menu></top-level-menu>
      </div>
    </div>
  </div>
</template>

<script>
import TrayMenu from './tray-menu/TrayMenu';
import PersonaSwitcher from './PersonaSwitcher';
import TopLevelLinks from './top-level-links/TopLevelLinks';
import TopLevelMenu from './top-level-menu/TopLevelMenu';
import PersonalizationWidget from './PersonalizationWidget';
import TopBarNotificationWidget from './TopBarNotificationWidget';
import { sessionManager } from 'vue-infra';


export default {
  name: 'top-bar',
  data() {
    return {
      hasPersonalization: false,
      mainNavBarAriaLabel: this.$translator.translate('LEFramework.navbar.main')
    };
  },
  created() {
    this.hasPersonalization = sessionManager.hasPersona('customizer');
  },
  components: {
    TrayMenu,
    TopLevelLinks,
    TopLevelMenu,
    PersonaSwitcher,
    PersonalizationWidget,
    TopBarNotificationWidget,
  },
};
</script>

<style lang='scss' scoped>
  @import "../../../assets/scss/global";
  @import "../../../assets/scss/mixins";

  .user-bar-menus {
    justify-content: center;
    position: absolute;
    bottom: 0px;
    box-sizing: border-box;
    padding-top: 30px;
    padding-bottom: 24px;
    width: $user-bar-width;
    @include themify {
      &:before {
        position: relative;
        margin: 0 auto;
        width: 1px;
        display: block;
        height: 40px;
        top: 14px;
        $header-divider: getAttr('nav-bar-header-divider', 'framework');
        @include lp-bg-image('assets/img/' + $header-divider);
        content: "";
        transform: translate(50%, -50%) rotate(-90deg);
      }
    }
  }

  .user-bar-main {

  }

  .user-bar-place-holder {
    height: 20px;
    width: 55px;
    position: absolute;
    top: 1px;
    @include themify {
      background-image: getColor('header-bg', 'framework');
    }
  }

  .user-bar-logo {
    border-right: 1px solid $black;
    width: 132px;
    height: 100%;
  }

  .user-bar-persona-switcher {
    position: absolute;
    width: 100%;
  }
</style>
